import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../shared/services/superadminusers/auth.service';

@Injectable({
    providedIn: 'root',
})
export class SuperadminAuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) { }

    canActivate(): boolean {
        if (this.authService.isSuperAdminLoggedIn()) {
            return true;
        }
        this.router.navigate(['/superadmin/login']);
        return false;
    }
}